// the production API; a local test build sets REACT_APP_API_URL (ae2-authors/dev/build-local.js)
const BASE_URL = process.env.REACT_APP_API_URL || "https://api.ae2authors.net";

const USER_FOLDER = (() => {
  if (process.env.NODE_ENV !== "production") {
    return;
  }
  if (typeof window === "undefined" || !window.__adobe_cep__) {
    return;
  }

  const path = decodeURI(window.__adobe_cep__.getSystemPath("userData"));
  const isMac = navigator.platform[0] === "M";
  return path.replace("file://" + (isMac ? "" : "/"), "");
})();

const EXTENSION_ID = (() => {
  if (process.env.NODE_ENV !== "production") {
    return "ae2";
  }

  if (typeof window !== "undefined" && window.__adobe_cep__) {
    return window.__adobe_cep__.getExtensionId();
  }

  return "ae2";
})();

export { BASE_URL, USER_FOLDER, EXTENSION_ID };
